import React from 'react';
import CostCalcTable from './CostCalcTable';
import { sumCostCalcs } from './costCalcShared';

// 확정된(읽기전용) 원가 산출 내역 표. 편집 표(CostCalcListForm)와 완전히 같은
// CostCalcTable을 그대로 쓴다(옵션 B, 2026-10-27 owner 승인 - "편집 상태와 확정 상태가
// 표를 공유") - 행 클릭/선택/패널만 없다.
const CostCalcLockList = ({ costs }) => {
  if (!costs || costs.length === 0) {
    return null;
  }

  const rows = costs.map((cost, index) => ({
    key: cost.id ?? index,
    no: index + 1,
    isEtc: cost?.masterTyp !== 'N',
    productNm: cost.productNm,
    productDesc: cost.productDesc,
    qty: cost.expCnt,
    unit: cost.productUnit,
    sellPrice: cost.unitVal,
    sellAmount: cost.saleVal,
    buyPrice: cost.priceVal,
    buyAmount: cost.buyVal,
    partnerNm: cost.sellPartnerNm,
    profit: cost.saleProfit,
    profitRate: cost.salePct,
    missingPartner: !cost.sellPartnerNm,
    invalid: false,
  }));

  const totals = sumCostCalcs(costs);

  return <CostCalcTable rows={rows} totals={totals} editable={false} />;
};

export default CostCalcLockList;
